import type { FC } from "react";
import { useState } from "react";

import ChevronDown from "@/assets/icons/chevron-down";
import ChevronUp from "@/assets/icons/chevron-up";
import Edit from "@/assets/icons/edit";
import { Button } from "@/components/ui/button";
import RiskLabel from "@/components/ui/risk-label";
import type { GravityState } from "@/types/api/patient";
import type { Risk } from "@/utils/patient";
import { getRiskColor, getRiskLabel } from "@/utils/patient";

type RiskFactorDropButtonProps = {
  state: GravityState;
  risk: Risk;
  children?: React.ReactNode;
  setRiskModalOpen: React.Dispatch<React.SetStateAction<Risk | "none">>;
  isOpenByDefault: boolean;
};

const RiskFactorDropButton: FC<RiskFactorDropButtonProps> = ({
  state,
  risk,
  children,
  setRiskModalOpen,
  isOpenByDefault,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(isOpenByDefault);

  return (
    <div className="flex flex-col border-b border-gray-200">
      {state !== "NONE" || isOpenByDefault ? (
        <Button
          type={"button"}
          variant={"text"}
          className={"w-full justify-between py-[10px] px-0"}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <RiskLabel
            risk={risk}
            color={getRiskColor(state)}
            text={getRiskLabel(risk)}
          />
          {isDropdownOpen ? <ChevronUp /> : <ChevronDown />}
        </Button>
      ) : (
        <div className="flex justify-between pb-[10px] pt-[10px]">
          <RiskLabel
            risk={risk}
            color={getRiskColor(state)}
            text={getRiskLabel(risk)}
            className="text-sm"
          />
          <Button
            type="button"
            variant="text"
            className="text-brand-800 gap-[2px]"
            size={"none"}
            onClick={() => setRiskModalOpen(risk)}
          >
            <Edit color="#8470FF" className="w-5 h-5" />
            <div className="font-semibold px-[2px]">Compléter</div>
          </Button>
        </div>
      )}
      {isDropdownOpen ? (
        <div className="flex flex-col py-[10px]">
          {children}
          <div className="flex justify-end">
            <Button
              type="button"
              variant="text"
              className="text-brand-800 gap-[2px] pt-2"
              size={"none"}
              onClick={() => setRiskModalOpen(risk)}
            >
              <Edit color="#8470FF" className="w-5 h-5" />
              <div className="font-semibold px-[2px]">Modifier</div>
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default RiskFactorDropButton;
